<ng-container>
    <div class="page-section">
        <div class="action-items-heading-section">
            <!-- <span class="action-items-heading" *ngIf="action_item_filter_tab_selected == 'day'">{{action_items_data.start_date | date: "d MMM yyyy"}}</span>
            <span class="action-items-heading" *ngIf="action_item_filter_tab_selected != 'day'">{{action_items_data.start_date | date: "d MMM yyyy"}} to {{action_items_data.end_date | date: "d MMM yyyy"}}</span> -->
            <div class="action-item-section">
                <ng-container *ngFor="let filter_tab of action_item_filter_tabs">
                    <div class="each-action-item-filters-section" [ngClass]="{'each-action-item-filters-section-selected': action_item_filter_tab_selected.value == filter_tab.value}" (click)="changeActionItemDuration(filter_tab)">
                        <span>{{filter_tab.name}}</span>
                    </div>
                    <div class="filter-tab-date-section" *ngIf="action_item_filter_tab_selected.id == filter_tab.id">
                        <img src="assets/calendar-prev.png" class="filter-tab-date-icon" (click)="changeDuration('Previous')" />
                        <img src="assets/calendar-next.png" class="filter-tab-date-icon" (click)="changeDuration('Next')" />
                        <ng-container *ngIf="action_item_filter_tab_selected.value == 'day'">
                            <span class="filter-tab-date">{{selceted_activity_start_date | date: "dd MMM yyyy"}}</span>
                            <input
                                type="text"
                                bsDatepicker
                                placement="right"
                                [(ngModel)]="selceted_activity_start_date"
                                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                                (ngModelChange)="changeDuration('Selected')"
                                id="day-calendar-view"
                                style="visibility: hidden; width: 0px;"
                            />
                            <label class="filter-tab-date-picker" for="day-calendar-view">
                                <img src="assets/calendar.png" class="filter-tab-date-picker-image" />
                            </label>
                        </ng-container>
                        <ng-container *ngIf="action_item_filter_tab_selected.value == 'week'">
                            <!-- <label class="filter-tab-date" for="week-calendar-view">{{selceted_activity_start_date | date: "dd MMM yyyy"}}</label> -->
                            <span class="filter-tab-date">{{selceted_activity_start_date | date: "dd MMM yyyy"}}</span>
                            <span class="filter-tab-date">-</span>
                            <span class="filter-tab-date">{{selceted_activity_end_date | date: "dd MMM yyyy"}}</span>
                            <!-- <input
                                type="text"
                                bsDatepicker
                                placement="right"
                                [(ngModel)]="selceted_activity_start_date"
                                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                                (ngModelChange)="changeDuration('Selected')"
                                id="week-calendar-view"
                                style="visibility: hidden; width: 0px;"
                            /> -->
                        </ng-container>
                        <ng-container *ngIf="action_item_filter_tab_selected.value == 'month'">
                            <span class="filter-tab-date">{{selceted_activity_start_date | date: "MMM yyyy"}}</span>
                            <input
                                type="text"
                                bsDatepicker
                                placement="right"
                                [(ngModel)]="selceted_activity_start_date"
                                [minMode]="'month'"
                                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                                (ngModelChange)="changeDuration('Selected')"
                                id="month-calendar-view"
                                style="visibility: hidden; width: 0px;"
                            />
                            <label class="filter-tab-date-picker" for="month-calendar-view">
                                <img src="assets/calendar.png" class="filter-tab-date-picker-image" />
                            </label>
                        </ng-container>
                        <ng-container *ngIf="action_item_filter_tab_selected.value == 'year'">
                            <span class="filter-tab-date">{{selceted_activity_start_date | date: "yyyy"}}</span>
                            <input
                                type="text"
                                bsDatepicker
                                placement="right"
                                [(ngModel)]="selceted_activity_start_date"
                                [minMode]="'year'"
                                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                                (ngModelChange)="changeDuration('Selected')"
                                id="year-calendar-view"
                                style="visibility: hidden; width: 0px;"
                            />
                            <label class="filter-tab-date-picker" for="year-calendar-view">
                                <img src="assets/calendar.png" class="filter-tab-date-picker-image" />
                            </label>
                        </ng-container>
                    </div>
                </ng-container>
            </div>
            <div class="graphical-representation-swicth" *ngIf="page_data_loaded">
                <div class="process-graph-switch">
                    <mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()"></mat-slide-toggle>
                </div>
                <span class="process-graph-switch-label" (click)="show_graphical_representation = !show_graphical_representation; toggleGraphs();">Graphical Representation</span>
            </div>
        </div>

        <ng-container *ngIf="page_data_loaded">
            <div class="new-summary-section">
                <div class="each-new-summary-section">
                    <p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_data['summary']['sent']) }}</p>
                    <p class="each-new-summary-section-label">Emails Sent</p>
                </div>
                <div class="each-new-summary-section">
                    <p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_data['summary']['opened']) }}</p>
                    <p class="each-new-summary-section-label">Emails Opened</p>
                </div>
                <div class="each-new-summary-section">
                    <p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_data['summary']['not_opened']) }}</p>
                    <p class="each-new-summary-section-label">Emails Not Opened</p>
                </div>
                <div class="each-new-summary-section">
                    <p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_data['summary']['interested']) }}</p>
                    <p class="each-new-summary-section-label">Interested</p>
                </div>
                <div class="each-new-summary-section">
                    <p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_data['summary']['not_interested']) }}</p>
                    <p class="each-new-summary-section-label">Not Interested</p>
                </div>
                <div class="each-new-summary-section">
                    <p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_data['summary']['talk_with_advisor']) }}</p>
                    <p class="each-new-summary-section-label" *ngIf="user_role != 'Recruiter'">Talk to Advisor</p>
                    <p class="each-new-summary-section-label" *ngIf="user_role == 'Recruiter'">Talk to Recruiter</p>
                </div>
            </div>

            <div class="page-content-section">
                <div class="page-graphs-section" *ngIf="show_graphical_representation">
                    <div class="each-dashboard-graph-block">
                        <div class="graph-inner-heading-section">
                            <img src="assets/events.png" class="graph-section-icon" />
                            <span>By Yearly Trends</span>
                        </div>
                        <div class="each-dashboard-graph-content">
                            <div id="yearly-trends-graph"></div>
                        </div>
                    </div>
                    <div class="each-dashboard-graph-block">
                        <div class="graph-inner-heading-section">
                            <img src="assets/events.png" class="graph-section-icon" />
                            <span>By Responses</span>
                        </div>
                        <div class="each-dashboard-graph-content">
                            <div id="responses-graph"></div>
                        </div>
                    </div>
                    <div class="each-dashboard-graph-block">
                        <div class="graph-inner-heading-section">
                            <img src="assets/events.png" class="graph-section-icon" />
                            <span>By Open Click Ratio</span>
                        </div>
                        <div class="each-dashboard-graph-content">
                            <div id="open-click-graph"></div>
                        </div>
                    </div>
                </div>

                <div class="summary-table-data-section">
                    <div class="summary-table-section">
                        <div>
                            <div class="new-table-v2-overflow">
                                <div class="new-table-heading-section">
                                    <span style="visibility: hidden;">AI Explainability</span>
                                    <div class="new-table-actions ml-4">
                                        <div class="each-action-section search-input-section" *ngIf="show_search">
                                            <!-- <input type="text" placeholder="Search" class="search-input" [(ngModel)]="search_key" (input)="current_pagination_page = 1; searchClients()" /> -->
                                            <!-- <span class="search-input-close" (click)=" show_search = false; search_key = ''; current_pagination_page = 1; searchClients()">&times;</span> -->
                                            <input type="text" placeholder="Search" class="search-input" [(ngModel)]="search_key" (input)="current_pagination_page = 1; getPageData()" />
                                            <span class="search-input-close" (click)=" show_search = false; search_key = ''; current_pagination_page = 1; getPageData()">&times;</span>
                                        </div>
                                        <div class="each-action-section search-icon" *ngIf="!show_search" (click)="show_search = true">
                                            <img src="assets/search.png" class="button-icon" />
                                            <span>Search</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="new-table-v2-overflow">
                                    <table class="new-table-v2">
                                        <thead>
                                            <tr>
                                                <th appColumnResizable>Actions</th>
                                                <th appColumnResizable>Emails</th>
                                                <th appColumnResizable>Client Name</th>
                                                <th appColumnResizable>Opportunity</th>
                                                <th appColumnResizable>Emails Sent</th>
                                                <th appColumnResizable>Emails Opened</th>
                                                <th appColumnResizable>Emails Not Opened</th>
                                                <th appColumnResizable>Interested</th>
                                                <th appColumnResizable>Not Interested</th>
                                            </tr>
                                        </thead>
                                        <ng-container *ngIf="table_data_loaded">
                                            <!-- <tbody *ngIf="filtered_data.length > 0"> -->
                                            <tbody *ngIf="page_data.total_records_table.length > 0">
                                                <!-- <ng-container *ngFor=" let client of filtered_data | paginate : { 	id: 'email-analytics-data', itemsPerPage: pagination_records_limit, currentPage: current_pagination_page, totalItems: filtered_data.length }; let clientIndex = index " > -->
                                                <ng-container *ngFor=" let client of page_data.total_records_table | paginate : { 	id: 'email-analytics-data', itemsPerPage: pagination_records_limit, currentPage: current_pagination_page, totalItems: total_pagination_records }; let clientIndex = index " >
                                                    <tr>

                                                        <td>
                                                            <img src="assets/view-tasks.png" class="client-table-icon" (click)="showUserProfile(client, 'Client')" *ngIf="client.is_client" />
                                                            <img src="assets/view-tasks.png" class="client-table-icon" (click)="showUserProfile(client, 'Lead')" *ngIf="!client.is_client" />
                                                        </td>
                                                        <td>
                                                            <img src="assets/ic-activities.png" class="client-table-icon" (click)="toggleActivityView(clientIndex)" />
                                                        </td>

                                                        <td>{{client.full_name}}</td>
                                                        <td>{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{commonService.abbreviateNumber(client.opportunity)}}</td>
                                                        <td>{{commonService.abbreviateNumber(client.total_sent)}}</td>
                                                        <td>{{commonService.abbreviateNumber(client.opened)}}</td>
                                                        <td>{{commonService.abbreviateNumber(client.not_opened)}}</td>
                                                        <td>{{commonService.abbreviateNumber(client.interested)}}</td>
                                                        <td>{{commonService.abbreviateNumber(client.not_interested)}}</td>
                                                    </tr>
                                                    <tr *ngIf="show_activity_view == clientIndex">
                                                        <td colspan="9" class="page-inner-view" style="overflow: visible;">
                                                            <ng-container>
                                                                <app-activity-table [activities_table_header]="activities_table_header" [activities_table_data]="client['activities']" [view_type]="'Activities'" [activity_action_type]="'View'" (activityDetailsUpdated)="activityDetailsUpdated($event)"></app-activity-table>
                                                            </ng-container>
                                                        </td>
                                                    </tr>
                                                </ng-container>
                                            </tbody>
                                            <!-- <tbody *ngIf="filtered_data.length == 0"> -->
                                            <tbody *ngIf="page_data.total_records_table.length == 0">
                                                <td colspan="9">
                                                    <div class="zero-state-section">
                                                        <span>No Data Found</span>
                                                    </div>
                                                </td>
                                            </tbody>
                                        </ng-container>
                                        <ng-container *ngIf="!table_data_loaded">
                                            <td colspan="9">
                                                <div class="zero-state-section">
                                                    <app-loader [loading_text]="'Loading Clients'"></app-loader>
                                                </div>
                                            </td>
                                        </ng-container>
                                    </table>
                                </div>
                                <div class="new-table-v2-pagination-section">
                                    <!-- <span class="mr-4">{{ filtered_data.length }} Records</span> -->
                                    <span class="mr-4">{{ total_pagination_records | number:'1.0-0' }} Records</span>
                                    <!-- <mat-select class="pagination-input" [(ngModel)]="pagination_records_limit" (selectionChange)="current_pagination_page = 1;"> -->
                                    <mat-select class="pagination-input" [(ngModel)]="pagination_records_limit" (selectionChange)="current_pagination_page = 1; getPageData();">
                                        <mat-option [value]="10">10</mat-option>
                                        <mat-option [value]="100">100</mat-option>
                                        <mat-option [value]="500">500</mat-option>
                                        <mat-option [value]="1000">1000</mat-option>
                                    </mat-select>
                                    <div class="new-table-v2-pagination-controls">
                                        <pagination-controls id="email-analytics-data" (pageChange)="pageChanged($event)" style="text-align: right; position: relative; top: 6px" ></pagination-controls>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

    </div>
</ng-container>

<ng-container *ngIf="!page_data_loaded">
    <app-loader [loading_text]="'Loading Email Analytics'"></app-loader>
</ng-container>


<ng-container *ngIf="show_user_profile == 'Client'">
	<app-customer-profile [data]="user_profile_data" [client_type]="'Client'" (profileClosed)="profileClosed($event)"></app-customer-profile>
</ng-container>

<ng-container *ngIf="show_user_profile == 'Lead'">
    <ng-container *ngIf="user_profile_data.source_type_id != 1 ">
        <app-lead-profile [data]="user_profile_data" (profileClosed)="profileClosed($event)"></app-lead-profile>
      </ng-container>
      <ng-container *ngIf="user_profile_data.source_type_id == 1 ">
        <app-bank-customer-profile [data]="user_profile_data" (profileClosed)="profileClosed($event)"></app-bank-customer-profile>
      </ng-container>
</ng-container>
